// *********** LOGIN() ***************************************
// *** Logincliente.jsx ***********
// *** autor: W de Paula / MVinfo *
// *** data: 05/05/24 | 09h59 *****
// *** data: 06/07/24 | 10h05 | implementação do token JWT
// *** data: 09/09/24 | 12h20 | melhoria das mensagens UX/UI após login mau sucedido
// ***********************************************************




import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { encrypt } from '../../Services/cryptoUtils';
import { encryptPass } from '../../Services/cryptosenha.js';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from '../../../src/Services/apiaxios';
import AgendexCliente from '../../Assets/agendex/logoagendexcliente.png';
import "./logincliente.css";

function Login() {
    var ano = new Date().getFullYear();

    const [emailcliente, setEmailCliente] = useState('');
    const [senhacliente, setSenhaCliente] = useState('');
    const [mensagem, setMensagem] = useState('');
    const navigate = useNavigate(); // Hook para navegação
    const [loading, setLoading] = useState(false); // loading na tela

    useEffect(() => {
        const logoutMessage = localStorage.getItem('logoutMessage');
        if (logoutMessage) {
            setMensagem(logoutMessage);
            localStorage.removeItem('logoutMessage'); // Limpar após exibir
        }
    }, []);

    async function LoginUsuario() {
        try {
            if (!emailcliente || !senhacliente) {
                setMensagem('Email ou Senha não pode ficar em branco.');
                setTimeout(() => {
                    setMensagem('');
                }, 5000);
                return;
            }
    
            setLoading(true);
    
            const response = await apiaxios.post('/usuario/loginWeb', {
                email: emailcliente,
                senha: encryptPass(senhacliente),
                tipoApp: 0
            });
    
            const data = response.data;
    
            const userVars = {
                id_usuario: Number(data.id_usuario),
                pais: data.pais,
                uf: data.uf,
                cidade: data.cidade,
                ativa_conta: Number(data.ativa_conta),
                TAMANHO_PAGINA: 15
            };
    
            const encryptedUser = encrypt(userVars);
    
            localStorage.setItem('tokenlg', encrypt("true"));
            localStorage.setItem('tokenacw', encryptedUser);
            localStorage.setItem('tokenasw', data.token);
            localStorage.setItem("buscaCidade", false);
            localStorage.removeItem('logoutMessage');
            localStorage.setItem('userType', '0'); // 0= 'cliente' / 1= 'prestador' // 23/9/24w
    
            navigate('/app/cliente/home');
        } catch (error) {
            // Se a resposta do servidor tiver uma mensagem de erro, capturá-la
            if (error.response && error.response.data && error.response.data.retorno) {
                setMensagem(error.response.data.retorno); // Mensagem vinda do servidor
            } else if (error.message.includes('CORS policy')) {
                setMensagem('Erro de CORS. Verifique as configurações do servidor.');
            } else if (error.message === 'Failed to fetch') {
                setMensagem('Erro de conexão. Verifique sua conexão com a internet e tente novamente.');
            } else {
                setMensagem(error.message);
            }
            setTimeout(() => {
                setMensagem('');
            }, 7000);
        } finally {
            setLoading(false);
        }
    }

    function ChangeMailCliente(element) {
        setEmailCliente(element.target.value);
    }
    
    function ChangePasswordCliente(element) {
        setSenhaCliente(element.target.value);
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            LoginUsuario();
        }
    };

    return (
        <section id="logincliente">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-1">
                        <img className="login-cliente-img" src={AgendexCliente} alt='Login Cliente'/>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        <div className={`row ${loading ? 'd-none' : ''}`}></div>

                        <form>
                            <div className="form-group mb-3">
                                <input onChange={ChangeMailCliente} type="email" className="form-control" id="emailcliente" name="emailcliente" placeholder="Digite seu Email cadastrado *" 
                                    autoComplete="username"  // Adiciona este atributo
                                    // onKeyPress={handleKeyPress} 
                                    onKeyDown={handleKeyPress} 
                                />
                            </div>
                            <div className="form-group mb-3">
                                <input onChange={ChangePasswordCliente} type="password" className="form-control" id="senhacliente" name="senhacliente" placeholder="Digite sua senha *" 
                                    autoComplete="current-password"  // Adiciona este atributo
                                    onKeyDown={handleKeyPress} 
                                />
                            </div>
                            <div className="form-group mb-4">
                                <input onClick={LoginUsuario} type="button" className="btnSubmit" value="► Login" 
                                    onKeyDown={handleKeyPress} 
                                />
                                
                                {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                            </div>
                            <div className="form-group">
                                <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                            </div>
                        </form>
                    </div>
                </div>
                <p className="text-sm">(*) campos obrigatórios.</p>
                <div className="textoRodape">
                    <Link to="/app/novaconta">Não tenho conta. Toque para criar uma agora.</Link>
                    <p>Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default Login;
